var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3832 9.94966H5.47656V16.9662H14.3832V9.94966Z",
    stroke: "#35308D",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2961 1.09349H6.625V6.15576H14.2961V1.09349Z",
    stroke: "#35308D",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86719 12.4106H12.4124",
    stroke: "#35308D",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86719 14.5388H12.4124",
    stroke: "#35308D",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.93841V14.4359C1 14.6846 1.09882 14.9235 1.27479 15.0995L2.867 16.6917C3.04298 16.8677 3.28156 16.9665 3.53063 16.9665H16.0281C16.5462 16.9665 16.9665 16.5465 16.9665 16.0281V1.93841C16.9665 1.4203 16.5465 1 16.0281 1H1.93841C1.41997 1 1 1.41997 1 1.93841Z",
    stroke: "#35308D",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIconBlue);
export default __webpack_public_path__ + "static/media/SaveIconBlue.edb9f68b2e40c96835b7d47f08b89a45.svg";
export { ForwardRef as ReactComponent };